/* global jsQR */
import Swal from "sweetalert2";

export const format_date = (dateString) => {
  if (!dateString) return "Date not set";
  return new Date(dateString).toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
};

export const format_time = (timeString) => {
  if (!timeString) return "";
  const [hour, minute] = timeString.split(":");
  const date = new Date();
  date.setHours(hour, minute);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
};

export const check_description = (description) => {
  if (!description || typeof description !== "string") return false;
  const plainText = description.replace(/<[^>]*>/g, "").trim();
  return plainText.length > 0;
};

export const truncate_description = (description, maxLength = 25) => {
  const words = (description || "").split(/\s+/).filter(Boolean);
  if (words.length > maxLength) {
    return `${words.slice(0, maxLength).join(" ")}...`;
  }
  return description;
};

export const is_promo_valid = (startDateStr, endDateStr) => {
  const now = new Date();
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  if (isNaN(start) || isNaN(end)) {
    return false;
  }
  return now >= start && now <= end;
};

export const show_toast = (message) => {
  const toastBody = document.querySelector("#copyToast .toast-body");
  if (toastBody) {
    toastBody.textContent = message;
  }
  $("#copyToast").fadeIn(300).addClass("show");
  setTimeout(() => {
    $("#copyToast").fadeOut(30).removeClass("show");
  }, 3000);
};

export const new_format_date = (dateString) => {
  if (!dateString) return "N/A";
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return new Date(dateString).toLocaleString(undefined, options);
};

export const get_event_media_files = (event) => {
  return event?.event_files.filter((file) => file?.event_file_type?.name === "event gallery");
};

export const get_event_resource_files = (event) => {
  return event?.event_files.filter((file) => file?.event_file_type?.name === "event resources");
};

export const get_event_media_type = (item) => {
  const type = String(item?.type || item?.file?.file_type || "").toLowerCase();
  const url = String(item?.file?.file_url || item?.previewUrl || "").toLowerCase();

  return (
    type.startsWith("image/") ||
    /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/.test(url)
  ) ? "image" : (
    type.startsWith("video/") ||
    /\.(mp4|webm|ogg|mov|m4v)(\?|$)/.test(url)
  ) ? "video" : (
    type.startsWith("audio/") ||
    /\.(mp3|wav|ogg|m4a|aac)(\?|$)/.test(url)
  ) ? "audio" : "unknown";
};

export const get_speaker_initials = (speaker) => {
  const first = (speaker?.first_name || "").trim();
  const last = (speaker?.last_name || "").trim();
  const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  return initials || "SP";
};

export const get_user_id = () => {
  return localStorage.getItem("user_id") || "";
};

export const validate_ticket_date = (ticketStartDate) => {
  const targetDate = new Date(ticketStartDate);
  const today = new Date();
  return targetDate <= today;
};

export const calculate_subtotal = (eventTickets) => {
  if (!Array.isArray(eventTickets)) return 0;
  return eventTickets.reduce((sum, ticket) => {
    const quantity = Number(ticket?.quantitySelected || 0);
    const price = Number(ticket?.price || 0);
    return sum + quantity * price;
  }, 0);
};

export const calculate_total = (eventTickets, appliedPromo) => {
  const subTotal = calculate_subtotal(eventTickets);
  const promo = appliedPromo;
  if (!promo) return subTotal.toFixed(2);
  const promoType = String(promo?.promo_code?.promo_code_type?.name || "").toLowerCase();
  const discountAmount = Number(promo?.promo_code?.discount_amount || 0);

  let total = subTotal;
  if (promoType === "percentage") {
    const percentage = Math.min(Math.max(discountAmount, 0), 100);
    total = subTotal - (subTotal * percentage) / 100;
  } else {
    total = subTotal - Math.max(discountAmount, 0);
  }
  total = Math.max(total, 0);
  return total.toFixed(2);
};

export const toggle_item = (selectedItemIds, itemId) => {
  const current = Array.isArray(selectedItemIds) ? selectedItemIds : [];
  const index = current.indexOf(itemId);
  if (index > -1) {
    return [];
  }
  return [itemId];
};

export const select_ticket = (ticket) => {
  if (!ticket) return null;
  if (!ticket.quantitySelected) {
    ticket.quantitySelected = 1;
  }
  return ticket.id ?? null;
};

export const increment_ticket = (ticket) => {
  if (!ticket) return null;
  const available = Number(ticket.available_instances ?? 0);
  const current = Number(ticket.quantitySelected || 0);
  return Math.min(available, current + 1);
};

export const decrement_ticket = (ticket) => {
  if (!ticket) return null;
  const current = Number(ticket.quantitySelected || 0);
  return Math.max(0, current - 1);
};

export const select_promo = (promo, on_success) => {
  if (!promo) return;
  navigator.clipboard.writeText(promo).then(() => {
    if (typeof on_success === "function") {
      on_success();
    }
  });
};

export const get_sponsor_initials = (sponsor) => {
  const name = String(sponsor?.name || "").trim();
  if (!name) return "SP";
  const parts = name.split(/\s+/).filter(Boolean);
  const initials = parts.slice(0, 2).map((part) => part.charAt(0)).join("").toUpperCase();
  return initials || "SP";
};

export const get_sponsor_logo = (sponsor) => {
  return sponsor?.logo?.file_url;
};

export const scroll_sponsors = (vm, direction) => {
  const ref = vm?.$refs?.sponsorScroll;
  if (!ref) return;
  const el = Array.isArray(ref) ? ref[0] : ref;
  if (!el || typeof el.scrollBy !== "function") return;
  const distance = 160 * (Number(direction) || 1);
  el.scrollBy({ left: distance, behavior: "smooth" });
  setTimeout(() => {
    update_sponsor_scroll_controls(vm);
  }, 200);
};

export const update_sponsor_scroll_controls = (vm) => {
  const ref = vm?.$refs?.sponsorScroll;
  if (!ref) return;
  const el = Array.isArray(ref) ? ref[0] : ref;
  if (!el) return;
  const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
  vm.show_sponsor_scroll_left = el.scrollLeft > 0;
  vm.show_sponsor_scroll_right = el.scrollLeft < maxScrollLeft - 1;
};

export const format_sponsor_url = (url) => {
  const value = String(url || "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
};

export const start_scanning = (vm, eventId) => {
  if (!vm) return;
  vm.scan_result_box = false;
  vm.scan_success = false;
  vm.scan_error_message = "";
  vm.scan_data = {};
  vm.current_event_id = eventId;
  vm.show_camera = true;
  vm.scanning = true;
  vm.is_processing = false;
  $("#scanModal").modal("show");
  $("#scanModal").on("shown.bs.modal", () => {
    vm.scanning = true;
    start_camera(vm);
  });
};

export const start_camera = (vm) => {
  if (!vm) return;
  const video = document.getElementById("video");
  const canvas = document.getElementById("canvas");
  if (!video || !canvas) return;
  const context = canvas.getContext("2d");

  navigator.mediaDevices
    .getUserMedia({ video: { facingMode: "environment" } })
    .then((stream) => {
      vm.video_stream = stream;
      video.srcObject = stream;
      video.setAttribute("playsinline", true);
      requestAnimationFrame(() => scan_loop(vm, video, canvas, context));
    })
    .catch((err) => console.error("Camera error:", err));
};

export const scan_loop = (vm, video, canvas, context) => {
  if (!vm || !vm.scanning) return;

  if (video.readyState === video.HAVE_ENOUGH_DATA) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const code = jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: "dontInvert" });

    if (code) {
      if (!vm.is_processing) {
        vm.is_processing = true;
        vm.scanResult = code.data;
        if (!vm.event?.is_free) {
          vm.validate_ticket(code.data);
        } else {
          vm.validate_rsvp(code.data);
        }
        setTimeout(() => {
          vm.is_processing = false;
        }, 2000);
      }
    }
  }
  requestAnimationFrame(() => scan_loop(vm, video, canvas, context));
};

export const stop_scanning = (vm) => {
  if (!vm) return;
  vm.scanning = false;
  if (vm.video_stream) {
    vm.video_stream.getTracks().forEach((track) => track.stop());
    vm.video_stream = null;
  }
  $("#scanModal").off("shown.bs.modal");
  $("#scanModal").modal("hide");
};

export const stop_camera_only = (vm) => {
  if (!vm) return;
  vm.scanning = false;
  if (vm.video_stream) {
    vm.video_stream.getTracks().forEach((track) => track.stop());
  }
};

export const restart_scan = (vm) => {
  if (!vm) return;
  vm.scan_result_box = false;
  vm.show_camera = true;
  vm.scan_error_message = "";
  vm.scan_data = {};
  vm.is_processing = false;
  vm.scanning = true;
  start_camera(vm);
};

export const export_to_csv = (event, isCboDomain) => {
  if (!event || !event.rsvp_list || event.rsvp_list.length === 0) {
    Swal.fire({
      icon: "warning",
      text: "No RSVP data available for export.",
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
    return;
  }
  const isCBO = !!isCboDomain;
  let csvHeader = "First Name,Last Name,Email,Phone Number,Event";
  if (isCBO) {
    csvHeader += ",Business Name,First Time Attending,Chapter";
  }
  csvHeader += ",Meal\n";

  const csvRows = event.rsvp_list.map((user) => {
    const firstName = user.user?.first_name || "";
    const lastName = user.user?.last_name || "";
    const email = user.user?.email || "";
    const phoneNumber = user.user?.phone_number || "";
    const eventName = user?.event_name || "";
    const meals = user.rsvp_items?.map((item) => item.item?.item_name).join(", ") || "";
    let row = `${firstName},${lastName},${email},${phoneNumber},${eventName}`;

    if (isCBO) {
      const business_name = user.business_name || "";
      const firstTime = user.is_first_time ? "Yes" : "No";
      const chapter = user.chapter || "";
      row += `,${business_name},${firstTime},${chapter}`;
    }
    row += `,"${meals}"`;
    return row;
  });
  const csvContent = csvHeader + csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = event.event_name + ".csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Move of view_event methods: fetchEvents_extras and apply_promo
export const fetchEvents_extras = (vm, event_id) => {
  if (!vm) return;
  vm.is_loading = true;
  vm.token_exists = vm.get_auth_token ? !!vm.get_auth_token() : false;
  vm.selected_item_id = [];
  vm.business_name = "";
  vm.is_first_time = false;
  vm.chapter = "";

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
    method: "GET",
    headers: {
      Authorization: `Token ${vm.get_auth_token ? vm.get_auth_token() : ""}`,
    },
    data: { event_id },
    success: (response_data) => {
      vm.event_extras = response_data.event_extras || [];
      if (vm.event_extras.length > 0) {
        $("#rsvp_modal").modal("show");
      } else {
        if (typeof vm.add_rsvp === "function") vm.add_rsvp();
      }
    },
    complete: () => {
      vm.is_loading = false;
    },
  });
};

export const apply_promo = (vm) => {
  if (!vm) return;
  const promo_code_name = (vm.promo_input || "").trim();
  if (!promo_code_name) return;
  if (!vm.selected_event?.id) {
    vm.promo_status = "error";
    vm.promo_message = "Please select an event first.";
    return;
  }
  vm.is_applying = true;
  vm.promo_message = "";
  vm.promo_status = "";

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/validate_event_promo_code/`,
    data: JSON.stringify({ promo_code_name, event_id: vm.selected_event.id }),
    contentType: "application/json",
    headers: {
      Authorization: `Token ${vm.get_auth_token ? vm.get_auth_token() : ""}`,
    },
    success: (response) => {
      if (response.status === "success") {
        vm.applied_promo = response.data || null;
        vm.promo_status = "success";
        vm.promo_message = response.message || "Promo code applied.";
      } else {
        vm.applied_promo = null;
        vm.promo_status = "error";
        vm.promo_message = response.message || "Invalid promo code.";
      }
    },
    error: (xhr) => {
      vm.applied_promo = null;
      vm.promo_status = "error";
      vm.promo_message = xhr?.responseJSON?.message || "Invalid promo code for this event.";
    },
    complete: () => {
      vm.is_applying = false;
    },
  });
};
